import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UpdateOdometerService} from "./services/update-odometer.service";
import {ClaimFormValidationService} from "../../services/claim-form-validation.service";
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import {debounceTime, distinctUntilChanged, Subject, switchMap} from "rxjs";
import {NgModel} from "@angular/forms";
import {v4 as uuidv4} from "uuid";

@Component({
  selector: 'app-odometer',
  templateUrl: './odometer.component.html',
  styleUrls: ['./odometer.component.scss']
})
export class OdometerComponent implements OnInit {
  @Input() claimDto!: ClaimDto;
  odometerUpdate$ = new Subject<number | null | undefined>();

  @ViewChild('odometerInput', { static: false }) odometerInput!: NgModel;
  @ViewChild('odometerRadio', { static: false }) odometerRadio!: NgModel;
  private componentId = uuidv4();
  private isOdometerValid = false;
  
  constructor(
    private updateOdometerService: UpdateOdometerService,
    private claimFormValidationService: ClaimFormValidationService,
  ) {
  }

  ngOnInit(): void {
    this.odometerUpdate$.pipe(
      debounceTime(2000),
      distinctUntilChanged(),
      switchMap(() => this.updateOdometerService.updateOdometer(this.claimDto.claimId, this.claimDto.odometerReading!, this.claimDto.odometerUnits))
    ).subscribe();

    this.claimFormValidationService.formValidationEvent$.subscribe(() => {
      this.validateOdometerReading();
    });
  }

  updateOdometer() {
    this.updateOdometerService.updateOdometer(this.claimDto.claimId, this.claimDto.odometerReading!, this.claimDto.odometerUnits).subscribe();
  }

  debounceOdometerUpdate() {
    this.odometerUpdate$.next(this.claimDto.odometerReading);
  }

  private validateOdometerReading() {
    this.odometerInput.control.markAsTouched();
    this.odometerRadio.control.markAsTouched();
    this.isOdometerValid = !this.odometerInput.control.errors && !this.odometerRadio.control.errors;
    this.claimFormValidationService.updateValidationResult(this.componentId, this.isOdometerValid);
  }

}
